import React, { useState } from "react";
import ProgressBar from "Components/Common/ProgressBar/ProgressBar";
import NoData from "Pages/Admin/InspectorAssign/components/NoData";

interface ProgressItem {
  label: string;
  value: string;
  isFlagged?: boolean;
  flagNote?: string;
}

export interface ProgressPhaseItem {
  id: string;
  label: string;
  value: string;
  isFlagged: boolean;
  notes: string[];
  flagNote?: string;
}

export interface ProgressPhaseData {
  key: string;
  label: string;
  weight: number;
  estimation: number;
  items: ProgressPhaseItem[];
}

interface ProgressListProps {
  items?: ProgressItem[];
  phases?: ProgressPhaseData[];
  note?: string[];
}

const ProgressList = ({ items = [], phases = [], note }: ProgressListProps) => {
  const [collapsed, setCollapsed] = useState<Record<string, boolean>>({});
  const toggle = (key: string) =>
    setCollapsed((prev) => ({ ...prev, [key]: !prev[key] }));

  return (
    <div className="progressCard">
      {phases.length > 0 ? (
        phases.map((phase) => {
          const isCollapsed = !!collapsed[phase.key];
          return (
            <div key={phase.key} style={{ marginBottom: "12px" }}>
              <div
                className="progRow progPhaseAccHeader"
                onClick={() => toggle(phase.key)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") toggle(phase.key);
                }}
              >
                <div>
                  <span className="progLabel progPhaseLabel">
                    {phase.label}
                    <span className="progPhaseWeight">
                      {phase.weight}% of total
                    </span>
                  </span>
                </div>

                <div style={{ flex: 1, minWidth: 0 }} className="progItemBar">
                  <ProgressBar
                    value={phase.estimation}
                    isFlagged={phase.items.some((i) => i.isFlagged)}
                  />
                </div>
                <div className="progVal progPhaseVal">
                  {phase.estimation.toFixed(1)}%
                  <span
                    className={`progPhaseChevron${isCollapsed ? " collapsed" : ""}`}
                  >
                    ▼
                  </span>
                </div>
              </div>

              {!isCollapsed && (
                <div className="progPhaseItems">
                  {phase.items.map((item) => {
                    const pct = parseInt(item.value);
                    return (
                      <div
                        key={item.id}
                        style={{
                          borderBottom: "1px solid var(--bd)",
                          padding: "10px 14px",
                        }}
                      >
                        <div className="progRow">
                          <span className="progLabel">{item.label}</span>
                          <div
                            style={{ flex: 1, minWidth: 0 }}
                            className="progItemBar"
                          >
                            <ProgressBar
                              value={pct}
                              isFlagged={item.isFlagged}
                            />
                          </div>
                          <span
                            className={`progVal${item.isFlagged ? " red" : ""}`}
                          >
                            {item.value}%
                          </span>
                        </div>
                        {item.isFlagged && item.flagNote && (
                          <div className="progItemFlagNote">
                            ⚠ CSC flagged — {item.flagNote}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })
      ) : items.length > 0 ? (
        items.map((item) => (
          <div key={item.label}>
            <div className="progRow">
              <span className="progLabel">{item.label}</span>
              <div style={{ flex: 1, minWidth: 0 }} className="progItemBar">
                <ProgressBar
                  value={parseInt(item.value)}
                  isFlagged={item.isFlagged}
                />
              </div>
              <span className={`progVal${item.isFlagged ? " red" : ""}`}>
                {item.value}%
              </span>
            </div>
            {item.isFlagged && item.flagNote && (
              <div className="progItemFlagNote">
                ⚠ CSC flagged — {item.flagNote}
              </div>
            )}
          </div>
        ))
      ) : (
        <NoData text="No progress data available" />
      )}

      {/* {note && note.length > 0 && (
        <div className="statusNote">
          {note.map((line, i) => (
            <div key={i}>{line}</div>
          ))}
        </div>
      )} */}
    </div>
  );
};

export default ProgressList;
